import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { secondary },
    breakpoints
  } = theme;

  return {
    root: {
      borderLeft: "1px solid #ddd",
      borderRight: "1px solid #ddd",
      "&.details": {
        borderLeft: "none",
        borderRight: "none"
      }
    },
    row: {
      display: "flex",
      alignItems: "flex-end",
      fontSize: 12,
      padding: "6px 10px",
      minHeight: 34,
      borderBottom: "1px solid #ddd",
      "&.details": {
        fontSize: 14,
        padding: "11px 20px 11px 16px",
        [breakpoints.down(Breakpoints.SS_320)]: {
          padding: "11px 12px 11px 12px"
        }
      }
    },
    mainRow: {
      justifyContent: "space-between",
      alignItems: "center",
      paddingRight: 8
    },
    rowValueWrapper: {
      display: "flex",
      alignItems: "center"
    },
    rowName: {
      textTransform: "capitalize"
    },
    subRow: {
      justifyContent: "flex-end",
      wordBreak: "break-word"
    },
    rowMainItem: {
      display: "flex",
      justifyContent: "flex-end"
    },
    imageIcon: {
      display: "none",
      fontSize: "14px !important",
      alignSelf: "flex-start",
      margin: "0 -2px 0 6px",
      opacity: 0.3,
      "&.details": {
        fontSize: "20px !important",
        marginRight: -4,
        marginLeft: 9
      }
    },
    accordion: {
      boxShadow: "none"
    },
    accordionSummary: {
      height: 42,
      borderBottom: "1px solid #ddd",
      "&.Mui-expanded": {
        borderBottomColor: "#ddd"
      }
    },
    accordionSummaryContent: {
      height: "100%",
      justifyContent: "flex-end",
      alignItems: "center",
      color: secondary.dark,
      textTransform: "capitalize"
    },
    expandIcon: {
      padding: 10,
      color: secondary.dark
    },
    accordionDetails: {
      display: "block",
      padding: 0
    },
    codedString: {
      textAlign: "end",
      wordBreak: "break-word"
    },
    toggle: {
      "&.horseDetailsView .MuiGrid-root": {
        fontSize: 14,
        [theme.breakpoints.down(Breakpoints.SS_320)]: {
          padding: "0 2px"
        }
      }
    },
    conditionNoteSection: {
      "& > div:not(:first-child)": {
        paddingBottom: 9
      },
      "&.horseDetailsView > div:not(:first-child)": {
        paddingBottom: 11
      }
    },
    conditionNotes: {
      textAlign: "end",
      fontStyle: "italic"
    }
  };
});
